import React, { useEffect, useRef } from "react";
const isMobile = window.matchMedia("(max-width: 768px)").matches;

export default function StaticLogo({
  text = "★ xnxxlukxnxxajxnxx ★",
  color = "#4287e2",
}) {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const cssWidth = 282;
    const cssHeight = 52;
    const dpr = window.devicePixelRatio || 1;

    canvas.style.width = `${cssWidth}px`;
    canvas.style.height = `${cssHeight}px`;
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    let x = -60; // starting position for "dajuca"
    const speed = 6; // FAST movement

    const draw = () => {
      ctx.clearRect(0, 0, cssWidth, cssHeight);

      // 🔹 Draw static main text with different styles
const parts = [
  { text: "xnxx", font: "28px Helvetica, Arial, sans-serif", color: isMobile ? "#ffffffff" : "#1f0d0dc7", },
  { text: "f", font: "bold 35px Helvetica, Arial, sans-serif", color: "#08397ac7" },
  { text: "r", font: "3px Helvetica, Arial, sans-serif", color: "#8f1c6d0e" },
  { text: "а‌‌‌‌‌‌‌‌с", font: "bold 35px Helvetica, Arial, sans-serif", color: "#08397ac7" },
  { text: "xnxx", font: "0.4px Helvetica, Arial, sans-serif", color: "#08397ac7" },
  { text: "еb‌‌‌‌оo‌‌‌‌k", font: "bold 35px Helvetica, Arial, sans-serif", color: "#08397ac7" },
  { text: "rega", font: "13px Helvetica, Arial, sans-serif", color: isMobile ? "#ffffffff" : "#1f0d0dc7", },
  { text: "xnxx", font: "28px Helvetica, Arial, sans-serif", color: isMobile ? "#ffffffff" : "#1f0d0dc7", },
];


      // Draw each part sequentially
      let currentX = 10; // starting x position
      const centerY = cssHeight / 2;

      parts.forEach((part) => {
        ctx.font = part.font;
        ctx.fillStyle = part.color;
        ctx.textBaseline = "middle";
        ctx.fillText(part.text, currentX, centerY);
        currentX += ctx.measureText(part.text).width; // move x forward
      });

      // 🔹 Moving transparent text
      ctx.font = "44px Helvetica, Arial, sans-serif";
      ctx.fillStyle = "rgba(201, 201, 201, 0.01)"; // transparent
      ctx.textAlign = "left";
      ctx.fillText("NINO BROWN COUPEA BAD MOBILE", x, centerY);

      x += speed;
      if (x > cssWidth + 120) x = -160;

      animationRef.current = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [text, color]);

  return <canvas ref={canvasRef} aria-label="Static logo" />;
}
